import {assert} from 'Asserts';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import ProcessTaskFileState from 'processes/process-task-details/ProcessTaskFileState';
import APIUtil from 'util/APIUtil';

import {getWorkspaceItemIdFromProcessItem, SidepanelProcessItem} from './ProcessManagementSidepanelConstants';

export default function openWorkspaceForProcessItem(processItem: SidepanelProcessItem): void {
  const workspaceItemId = getWorkspaceItemIdFromProcessItem(processItem);
  if (APIUtil.isProcess(workspaceItemId)) {
    FileBrowserActions.openFile(workspaceItemId);
  } else if (APIUtil.isProcessTask(workspaceItemId)) {
    FileBrowserActions.openFile(workspaceItemId, {
      onOpen: (fileState: ProcessTaskFileState | undefined) => {
        fileState?.activateTabBasedOnSourceId(processItem.id);
      },
    });
  } else {
    assert(false, `Expected workspace item ID "${workspaceItemId}" to be either task or process`);
  }
}
